<template>
<div class="chapter">
<div class="inner_page">
<section class="level1" data-number="2" epub:type="part" id="london-april-1914">
<h1 data-number="2" epub:type="part">London, April 1914</h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4b887d68